<template>
    <div class="container">
        <div ref="toolbarDomRef" class="toolbar"></div>
        <div ref="editorDomRef" class="guides-editor"></div>
    </div>
</template>

<script>
import { createEditor, defaultConfig } from "@tencent/exeditor3-preset-editor";
import { PicturePlugin } from "@tencent/exeditor3-plugin-picture";

export default {
    name: "PresetEditor",
    props: ["content"],
    data() {
        return {
            editor: null
        };
    },
    mounted() {
        this.editor = createEditor({
            root: this.$refs.editorDomRef,
            toolbarRoot: this.$refs.toolbarDomRef,
            toolbar: {
                ...defaultConfig.toolbar
            },
            initialContent: this.isHTML(this.content) ? this.content : "",
            placeholder: "请输入",
            onCopy: isSuccess => {
                if (isSuccess) {
                    // 链接等插件复制成功回调
                }
            },
            plugins: [
                // 图片上传处理
                new PicturePlugin({
                    upload: file => this.uploadImgHandle(file)
                })
            ],
            iconPack: undefined,
            languagePack: undefined
        });
        this.editor.on("idlechange", e => {
            if (!e.docChanged) {
                return;
            }
            // 每次内容有编辑时，获取所有标题节点信息
            const content = this.editor.getHTML();
            const reg = /<div((?!<div).)*data-fail="fail"((?!<\/div>).)*<\/div>/g;
            const res = reg.test(content);
            if (res) {
                // 有错误的图片 替换成空
                const data = content.replace(reg, "");
                this.editor.setHTML(data)
            }
            this.$emit("guideDataHandle", this.editor.getHTML());
        });
    },
    methods: {
        isHTML(text) {
            try {
                const fragment = new DOMParser().parseFromString(text, "text/html");
                return fragment.body.children.length > 0;
                // eslint-disable-next-line no-empty
            } catch (error) {}
            return false;
        },
        uploadImgHandle(file) {
            if (file.size / 1024 / 1024 > 1) {
                this.$message({
                    message: "图片大小不能超过1M！",
                    type: "warning"
                });
                throw Error;
            }
            const formData = new FormData();
            formData.append("file", file, file.name);
            return this.zhiji
                .requestByServiceName("uploadImage", formData)
                .then(result => {
                    return `https:${result.url}`;
                })
                .catch(err => {
                    throw err;
                });
        }
    }
};
</script>

<style scoped lang="less">
.container {
    border: 1px solid #ebedf0;

    .toolbar {
        position: sticky;
        top: -20px;
        z-index: 1;
        padding-top: 20px;
        background: #fff;
    }
    .guides-editor {
        position: relative;
        z-index: 0;
        ::v-deep strong {
            font-style: inherit;
            font-weight: bold;
        }
        ::v-deep h1 {
            display: block;
            font-size: 2em;
            margin-block-start: 0.67em;
            margin-block-end: 0.67em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;
            font-weight: bold;
        }
        ::v-deep h2 {
            display: block;
            font-size: 1.5em;
            margin-block-start: 0.83em;
            margin-block-end: 0.83em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;
            font-weight: bold;
        }
        ::v-deep sub {
            vertical-align: sub;
        }
        ::v-deep sup {
            vertical-align: super;
        }
    }
}
</style>
